import { getState, unlockSkill } from './coreGameLogic';

let skills = [];

export async function loadSkills(skillsDataPath) {
  try {
    const response = await fetch(skillsDataPath);
    if (!response.ok) throw new Error('Failed to load skills');
    skills = await response.json();
  } catch (error) {
    console.error('Skill load error:', error);
    skills = [];
  }
}

export function getSkills() {
  return skills;
}

export function canUnlockSkill(skillId) {
  const state = getState();
  const skill = skills.find(s => s.id === skillId);
  if (!skill) return false;
  if (state.unlockedSkills.includes(skillId)) return false;
  if (state.xp < skill.xpRequired) return false;

  // Check dependencies
  for (const dep of skill.dependencies) {
    if (!state.unlockedSkills.includes(dep)) return false;
  }

  return true;
}

export function tryUnlockSkill(skillId) {
  if (!canUnlockSkill(skillId)) return false;
  return unlockSkill(skillId);
}